import { Link } from 'react-router-dom'
import { SpartanHelmet } from '@/components/icons/spartan-helmet'
import { LanguageSwitcher } from '@/components/landing/language-switcher'
import { HeroSection } from '@/components/landing/hero-section'
import { FeaturesSection } from '@/components/landing/features-section'
import { HowItWorks } from '@/components/landing/how-it-works'
import { SocialProof } from '@/components/landing/social-proof'
import { CtaSection } from '@/components/landing/cta-section'
import { Footer } from '@/components/landing/footer'

export function LandingPage() {
  return (
    <div className="min-h-screen bg-background">
      {/* Navbar */}
      <nav className="fixed top-0 left-0 right-0 z-50 border-b border-gray-800/50 bg-background/80 backdrop-blur-md">
        <div className="max-w-7xl mx-auto px-4 h-14 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <SpartanHelmet className="w-7 h-7 text-indigo-400" />
            <span className="text-lg font-bold text-gradient-primary">ARCHON</span>
          </Link>
          <LanguageSwitcher />
        </div>
      </nav>

      <HeroSection />
      <FeaturesSection />
      <HowItWorks />
      <SocialProof />
      <CtaSection />
      <Footer />
    </div>
  )
}
